import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Button } from "@mui/material";

function createData(hireDate, name, discipline, daysLeft, date) {
  return { hireDate, name, discipline, daysLeft, date };
}

const rows = [
  createData("19-02-2023", "Cameron Williamson", "PT", "8", "19-05-2023"),
  createData("19-02-2023", "Cameron Williamson", "PT", "8", "19-05-2023"),
  createData("19-02-2023", "Cameron Williamson", "PT", "8", "19-05-2023"),
  createData("19-02-2023", "Cameron Williamson", "PT", "8", "19-05-2023"),
];

function AnnualEvaluation() {
  const customColor = "#98A2B3"; // Replace with your desired hex color

  const buttonStyle = {
    borderColor: customColor,
    color: customColor,
  };

  return (
    <div className="dashboard-table annual-table">
      <div className="text-[#98A2B3] bg-white h-[5rem]  text-[14px] font-[700] rounded-t-lg flex items-center pl-4 mt-8  justify-between pr-4">
        <div className="font-bold">Annual Evaluation</div>
        <div>
          <Button variant="outlined" style={buttonStyle}>
            March
          </Button>
        </div>
      </div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ bgcolor: "#FAFAFB" }}>
            <TableRow>
              <TableCell
                align="left"
                className="!font-bold !text-[#292727] dashboardHeadCells"
              >
                Hire date
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#292727] dashboardHeadCells"
              >
                Name
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#292727] dashboardHeadCells"
              >
                Discipline
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#292727] dashboardHeadCells"
              >
                Days Left
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#292727] dashboardHeadCells"
              >
                Date
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left" className="dashboardTableCell">
                  {row.hireDate}
                </TableCell>
                <TableCell align="left" className="dashboardTableCell">
                  {row.name}
                </TableCell>
                <TableCell align="left" className="dashboardTableCell">
                  {row.discipline}
                </TableCell>
                <TableCell align="left" className="dashboardTableCell">
                  {row.daysLeft}
                </TableCell>
                <TableCell align="left" className="dashboardTableCell">
                  {row.date}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default AnnualEvaluation;
